import React from 'react';
import { Box, Flex } from 'rebass';

import {
  FormHeader,
  AssetSuccess,
  FormSubHeader,
  ButtonLarge,
  EmailSent,
  BackToLogin,
} from '@mdlinx/component-library';

import { FormContainer } from 'app/components/layout/form-container';

export const PasswordResetConfirmation = ({ onClickClose }: { onClickClose?: () => void }) => (
  <FormContainer>
    <Box>
      <FormHeader>Password Reset</FormHeader>
      <Box my="30px">
        <AssetSuccess />
      </Box>
      <FormSubHeader>Your account password has been successfully reset.</FormSubHeader>
      <Box my="30px">
        <ButtonLarge onClick={onClickClose}>Close</ButtonLarge>
      </Box>
    </Box>
  </FormContainer>
);

interface CheckInboxProps {
  onClickBack?: () => void;
  messageBody?: string;
}

export const CheckInbox = ({ onClickBack, messageBody }: CheckInboxProps) => (
  <FormContainer>
    <Box>
      <FormHeader>Check your Inbox</FormHeader>
      <Box mt="20px">
        <FormSubHeader>
          {messageBody ?? 'An email has been sent to the address you provided with a link to reset your password.'}
        </FormSubHeader>
        <Box my="20px" />
        <FormSubHeader>Check your spam folder if you cannot find the email in your inbox.</FormSubHeader>
      </Box>
      <Flex mt="46px" mb="63px" justifyContent="center" alignItems="center">
        <EmailSent />
      </Flex>

      <BackToLogin onClick={onClickBack} />
    </Box>
  </FormContainer>
);
